'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

function VerifyPropsProvider(context, functionDetails) {
  try {
    JSON.stringify(context.props);
  } catch (e) {
    (0, _utils.throwError)('The function ' + functionDetails.name + ' in signal ' + context.execution.name + ' is not given a valid payload');
  }

  return context;
}

exports.default = VerifyPropsProvider;
//# sourceMappingURL=VerifyProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/lib/providers/VerifyProps.js
// module id = 715
// module chunks = 0